import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './ImagePickerModal.css';
import { useState } from 'react';
import ModalDialog from './ModalDialog';
import { TextButton } from '../widgets';
import { checkmarkIcon } from '../icons';
const ImagePickerModal = ({ show, onClose, onSelect, images, title = 'Select Image' }) => {
    const [selectedImageName, setSelectedImageName] = useState(null);
    const handleSelectImage = (image) => {
        setSelectedImageName(image.name);
    };
    const handleConfirm = () => {
        if (selectedImageName) {
            onSelect(selectedImageName);
            setSelectedImageName(null);
            onClose();
        }
    };
    const handleClose = () => {
        setSelectedImageName(null);
        onClose();
    };
    return (_jsx(ModalDialog, { show: show, title: title, onClose: handleClose, closeButton: "close", minWidth: "600px", className: "imagePickerModal", children: _jsxs("div", { className: "imagePickerContent", children: [images.length === 0 ? (_jsx("div", { className: "imagePickerEmpty", children: "No images available" })) : (_jsx("div", { className: "imagePickerGrid", children: [...images].reverse().map((image) => {
                        const isSelected = selectedImageName == image.name;
                        const w400 = image.url.replace(/\.(png|jpg|jpeg|webp|gif)$/i, '-w400.webp');
                        const w600 = image.url.replace(/\.(png|jpg|jpeg|webp|gif)$/i, '-w600.webp');
                        return (_jsxs("div", { className: `imagePickerItem ${isSelected ? 'selected' : ''}`, onClick: () => handleSelectImage(image), children: [_jsxs("div", { className: "imagePickerImageWrapper", children: [_jsx("img", { src: w400, srcSet: `${w400} 400w, ${w600} 600w`, sizes: "(max-width: 768px) 100vw, (max-width: 1200px) 600px, 400px", alt: image.name, className: "imagePickerImage", onError: (e) => {
                                                // Fallback to original if scaled versions don't exist
                                                e.target.src = image.url;
                                            } }), isSelected && (_jsx("div", { className: "imagePickerSelectedOverlay", children: _jsx("div", { className: "imagePickerSelectedIcon", children: "\u2713" }) }))] }), _jsx("div", { className: "imagePickerName", children: image.name })] }, image.name));
                    }) })), _jsxs("div", { className: "imagePickerActions", children: [_jsx(TextButton, { label: "Cancel", onClick: handleClose, focussable: "flow", type: "minor" }), _jsx(TextButton, { label: "Select", icon: checkmarkIcon, onClick: handleConfirm, focussable: "flow", type: "major", enabled: selectedImageName ? 'enabled' : 'disabled' })] })] }) }));
};
export default ImagePickerModal;
